"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as a } from "react";
import t from "../components/Icon/SvgIcon.js";
const e = (l) => /* @__PURE__ */ o(
  t,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...l,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14.3 13.457V3.333h1.996v4.459a.5.5 0 0 0 1 0v-4.46h2.125v10.125zm-3.189 4.835a3 3 0 0 1 1.931-2.203V11.9H4.987a1.75 1.75 0 0 0-1.691 1.75v2.83a3 3 0 0 1 4.685 1.812zm3.189-2.364a3 3 0 1 1-3.189 3.614h-3.13a3.001 3.001 0 0 1-5.926-.863 1 1 0 0 1-.01-.137v-4.893c0-1.306.836-2.417 2-2.83V4.793a1 1 0 0 1 1-1h5.325a1 1 0 0 1 .928.627l1.752 4.366V3.208c0-.622.503-1.125 1.125-1.125h5.37c.622 0 1.126.503 1.126 1.125v10.25h.658a.625.625 0 0 1 0 1.25H14.3zM10.2 5.042l2.25 5.607H7.96l-.42-2.928a.5.5 0 1 0-.99.142l.399 2.786H5.296V5.042zM5.047 20.667a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5m10.75-1.75a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0",
        clipRule: "evenodd"
      }
    )
  }
), i = a(e);
export {
  i as Forklift,
  i as default
};
